function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgReports = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fillOpacity: 1
  },
  d: "M22.8 2.398H1.2c-.66 0-1.2.54-1.2 1.204V16.8C0 17.46.54 18 1.2 18h8.402v2.398H4.8a.602.602 0 0 0 0 1.204h14.398a.602.602 0 0 0 0-1.204h-4.8V18H22.8c.66 0 1.199-.54 1.199-1.2V3.603c0-.664-.54-1.204-1.2-1.204Zm-9.6 18h-2.4V18h2.4Zm9.6-3.597H1.2V3.6h21.6Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fillOpacity: 1
  },
  d: "M20.398 9c.332 0 .602-.27.602-.602V6a.602.602 0 0 0-.602-.602H18a.602.602 0 0 0 0 1.204h.953l-4.691 4.691L7.43 8.445a.603.603 0 0 0-.73.223l-2.5 3.75V6a.601.601 0 0 0-.598-.602A.602.602 0 0 0 3 6v8.398c0 .332.27.602.602.602h16.796a.601.601 0 1 0 0-1.2H4.723l2.703-4.058 6.742 2.813c.223.09.484.039.656-.13l4.977-4.976v.95c0 .331.27.601.597.601Zm0 0"
}));
export default SvgReports;